export default "__VITE_ASSET__BKoE4Sul__"